<template>
  <div>
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :title="materialstandardmapping.pkid > 0 ? '编辑':'新建'"
        width="1200px"
        top="5vh"
        @close="$reset('form')">
      <el-form ref="form" :model="materialstandardmapping" :rules="ruleValidate">
        <el-form-item label="产品名称" label-width="100px" prop="materialName">
          <div style="width: 500px;">
            <el-input v-model="materialstandardmapping.materialName" readonly>
              <el-button slot="append" icon="el-icon-search" :disabled="materialstandardmapping.pkid>0"
                         @click="$refs.selectMaterial.open()"/>
            </el-input>
          </div>
        </el-form-item>
        <el-table height="65vh"
                  ref="refTable"
                  :data="materialstandardmappings"
                  style="width: 100%;"
                  type="expand">
          <!--        <el-table-column label="产品名称">-->
          <!--          <template v-slot="scope">-->
          <!--            <el-input v-model="scope.row.materialName"/>-->
          <!--          </template>-->
          <!--        </el-table-column>-->
          <el-table-column label="特性名称">
            <template v-slot="scope">
              <el-input v-model="scope.row.propertyName"/>
            </template>
          </el-table-column>
          <el-table-column label="映射名称">
            <template v-slot="scope">
              <el-input v-model="scope.row.standardPropertyName"/>
            </template>
          </el-table-column>
          <el-table-column label="默认值" width="120px">
            <template v-slot="scope">
              <el-input v-model="scope.row.standardPropertyValue"/>
            </template>
          </el-table-column>
          <el-table-column label="数据类型" width="120px">
            <template v-slot="scope">
              <el-select v-model.trim="scope.row.dataType" placeholder="请选择">
                <el-option
                    v-for="item in dataTypes"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"/>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="是否多选" width="100px">
            <template v-slot="scope">
              <el-switch
                  v-model="scope.row.valueType"
                  style="display: block"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  active-text="是"
                  :active-value="1"
                  inactive-text="否"
                  :inactive-value="0"/>
            </template>
          </el-table-column>
          <el-table-column width="100px">
            <template #header>
              <el-button type="text" @click="clickRowAdd"> + 添加特性</el-button>
            </template>
            <template v-slot="scope">
              <el-button type="text" style="color: red;font-size: 12px;" @click="clickRowDel(scope.$index)">删除
              </el-button>
            </template>
          </el-table-column>

        </el-table>
        <product-control-box-select ref="selectMaterial" @select="selectProduct"/>
      </el-form>
      <span slot="footer">
      <el-button @click="dialogVisible=false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">
        保存
      </el-button>
    </span>
    </el-dialog>
  </div>
</template>

<script>
  import constant from "@/util/constant";
  import ProductControlBoxSelect from "../Product/ProductControlBoxSelect";

  export default {
    name: "MaterialStandardMappingEdit",
    components: {ProductControlBoxSelect},
    data() {
      return {
        dialogVisible: false,
        dataTypes: constant.toSelect(constant.dataType),
        valueTypes: constant.toSelect(constant.valueType),
        contentLoading: false,
        submitLoading: false,
        isCopy: 0,
        materialstandardmappings: [],
        materialstandardmapping: {
          pkid: 0,
          materialName: "",
          valueType: "",
          dataType: "",
          standardPropertyName: "",
          propertyValue: "",
          propertyName: "",
          standardPropertyValue: "",
        },
        ruleValidate: {
          materialName: {required: true, message: "不能为空", trigger: "blur"},
        },
      };
    },
    methods: {
      open: function(materialName, isCopy) {
        if (isCopy === 1) {
          this.isCopy = 1;
        }
        this.materialstandardmappings.pkid = 0;
        this.materialstandardmappings = [];
        if (materialName) {
          // this.materialstandardmapping.materialName = materialName;
          this.getData(materialName);
        }
        this.dialogVisible = true;
      },
      getData(materialName) {
        this.$http
            .get("basic", `materialstandardmappings/name/${encodeURIComponent(materialName)}`)
            .then(resp => {
              if (resp.success) {
                //处理复制订单信息
                resp.data.forEach((item, index) => {
                  if (this.isCopy === 1) {
                    item.pkid = 0;
                    item.materialName = "";
                  }
                  this.materialstandardmappings.push(item);
                });

                // this.materialstandardmappings = resp.data;
                this.materialstandardmapping = this.materialstandardmappings[0];
              }
            });
      },
      clickRowDel(index) {
        this.materialstandardmappings.splice(index, 1);
      },
      clickRowAdd() {
        let item = {
          materialName: "",
          valueType: 0,
          dataType: 1000,
          standardPropertyName: "",
          propertyValue: "",
          propertyName: "",
          standardPropertyValue: "",
        };
        this.materialstandardmappings.push(item);
      },

      selectProduct(row) {
        this.materialstandardmapping.materialName = row.materialName;
      },
      handleSubmit() {
        let isAdd = 0;
        if (this.materialstandardmapping.pkid === 0) {
          isAdd = 1;
        }
        this.materialstandardmappings.forEach(item => {
          item.materialName = this.materialstandardmapping.materialName;
        });

        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
                .post("basic", `materialstandardmappings/save/${isAdd}`, this.materialstandardmappings)
                .then((resp) => {
                  console.log(resp);
                  if (resp.success) {
                    this.submitLoading = false;
                    this.dialogVisible = false;
                    this.$emit("save-success");
                    this.$message.success("保存成功");
                  } else {
                    this.$message.error(resp.message);
                    this.submitLoading = false;
                  }

                })
                .catch(() => {
                  this.submitLoading = false;
                });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
